import { memo, useEffect, useRef, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { SecondaryButton, TextEditor } from 'ui_kit_qmd'
import cl from 'classnames'
import {
  EDIT_TEXT,
  PAST_VISIT_NOTES_SECTION_ADDENDUM_BTN_TITLE,
  TYPE_SOMETHING_TEXT,
  VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE,
} from '../../../../../utils/constants'
import './NotesSection.scss'
import NoteSectionItemTextCreator from '../../../../../components/NoteSectionItemTextCreator/NoteSectionItemTextCreator'
import { NotesItemsList } from './NotesItemsList/NotesItemsList'

const addendumBtnContainerStyle = {
  height: 40,
  width: 116,
  boxSizing: 'border-box',
}

const editBtnContainerStyle = {
  width: 55,
}

export const NotesSection = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    title,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    description,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    notesList = [],
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setInitialValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isWithoutSeparator,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isNotCompleted,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    emptyText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    className = '',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isAddendumTextEditorActive,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onPressAddendum,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onCancelAddendum,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEndedStatus,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isCancelledStatus,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    editorTitle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSetNewAddendumText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSaveAddendum,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    addendumLocalError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    addendumRef,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    autoSave,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    newValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isUpcomingVisit,
  }) => {
    const noteEditorRef = useRef()
    const enableHTML = true
    const [isValueWasInitialySetted, setIsValueWasInitialySetted] = useState(false)

    const isFirstNote =
      (isUpcomingVisit && isNotCompleted && !notesList.length && title === VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE) ||
      (!isUpcomingVisit && isNotCompleted && !notesList.length)

    const canShowNotesList =
      isUpcomingVisit || isNotCompleted ?
        !isAddendumTextEditorActive && notesList?.length
      : !isFirstNote && notesList?.length

    const canShowEmptyText =
      (!isUpcomingVisit && !notesList.length && !isFirstNote) ||
      (isUpcomingVisit && !notesList.length && (!isNotCompleted || title !== VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE))

    useEffect(() => {
      if (isNotCompleted || isUpcomingVisit) {
        if (notesList?.length) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          noteEditorRef.current?.onSetValue(notesList[0].Message || '')
          setValue(notesList[0].Message || '')
          setInitialValue(notesList[0].Message || '')
        } else {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          noteEditorRef.current?.onSetValue('')
          setValue('')
          setInitialValue('')
        }
        setIsValueWasInitialySetted(true)
      }
    }, [isNotCompleted, notesList.length, isAddendumTextEditorActive])

    useEffect(() => {
      if (isNotCompleted && isValueWasInitialySetted) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        noteEditorRef.current?.onSetValue(newValue)
        setValue(newValue)
        setInitialValue(newValue)
      }
    }, [newValue])

    useEffect(
      () => () => {
        if (autoSave && !isUpcomingVisit) {
          autoSave(true)
        }
      },
      [],
    )

    return (
      <div className={className}>
        <div className='notes-section-header'>
          <div
            className={cl('notes-section-text notes-section-title', {
              'notes-section-notes-title': title === 'Note' || isUpcomingVisit,
            })}>
            {title}
          </div>
          {(
            ((isUpcomingVisit && title === VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE && isNotCompleted && notesList.length) ||
              (!isUpcomingVisit && isNotCompleted && !isFirstNote)) &&
            !isAddendumTextEditorActive
          ) ?
            <div>
              <SecondaryButton
                btnText={EDIT_TEXT}
                containerStyle={{ ...addendumBtnContainerStyle, ...editBtnContainerStyle }}
                onPress={onPressAddendum}
              />
            </div>
          : null}{' '}
          {!isAddendumTextEditorActive && !isEndedStatus && !isCancelledStatus && !isUpcomingVisit && (
            <div>
              <SecondaryButton
                btnText={PAST_VISIT_NOTES_SECTION_ADDENDUM_BTN_TITLE}
                containerStyle={addendumBtnContainerStyle}
                onPress={onPressAddendum}
              />
            </div>
          )}
        </div>
        {description ?
          <div className='notes-section-text notes-section-description'>{description}</div>
        : null}
        {isFirstNote ?
          <TextEditor
            placeHolderText={TYPE_SOMETHING_TEXT}
            id={`noteEditor${title.split(' ').join('')}`}
            setText={setValue}
            ref={noteEditorRef}
            enableHTML={enableHTML}
          />
        : null}
        {!!canShowNotesList && <NotesItemsList notesList={notesList} emptyText={emptyText} />}
        {canShowEmptyText ?
          <div className='prescriptions-section-text prescriptions-section-no-prescriptions-tile'>{emptyText}</div>
        : null}
        <div ref={addendumRef} />
        {isAddendumTextEditorActive ?
          <div className={cl({ 'note-section-item-creator-wrapper': isUpcomingVisit || isNotCompleted })}>
            <NoteSectionItemTextCreator
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              textEditorRef={noteEditorRef}
              editorTitle={!isUpcomingVisit && !isNotCompleted && editorTitle}
              setText={isUpcomingVisit || isNotCompleted ? setValue : onSetNewAddendumText}
              onCancelPress={onCancelAddendum}
              onSavePress={isUpcomingVisit || isNotCompleted ? autoSave : onSaveAddendum}
              isError={addendumLocalError}
              localError={addendumLocalError}
              enableHTML={enableHTML}
            />
          </div>
        : null}
        {!isWithoutSeparator && <div className='notes-section-separator' />}
      </div>
    )
  },
)
